export function createAdvancedSearchFilters() {
  return {
    statusFilters: {
      filters: [],
      isAnd: false
    },
    typeFilters: {
      filters: [],
      isAnd: false
    },
    ownerFilters: {
      filters: [],
      isAnd: false
    },
    specialtyFilters: {
      filters: [],
      isAnd: false
    },
    facilityFilters: {
      filters: [],
      isAnd: false
    },
    certificationFilters: {
      filters: [],
      isAnd: false
    },
    stateLicenseFilters: {
      filters: [],
      isAnd: false
    },
    stateAddressFilters: {
      filters: [],
      isAnd: false
    },
    proximityToFacility: {
      facility: {},
      miles: ''
    },
    createdDate: '',
    hasCompact: false
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/providers/models/ProviderAdvancedSearchModel.ts